var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDbGraph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.75 2.75C2.75 1.98945 2.13555 1.375 1.375 1.375C0.614453 1.375 0 1.98945 0 2.75V17.1875C0 19.0867 1.53828 20.625 3.4375 20.625H20.625C21.3855 20.625 22 20.0105 22 19.25C22 18.4895 21.3855 17.875 20.625 17.875H3.4375C3.05938 17.875 2.75 17.5656 2.75 17.1875V2.75ZM20.2211 6.47109C20.7582 5.93398 20.7582 5.06172 20.2211 4.52461C19.684 3.9875 18.8117 3.9875 18.2746 4.52461L13.75 9.05352L11.2836 6.58711C10.7465 6.05 9.87422 6.05 9.33711 6.58711L4.52461 11.3996C3.9875 11.9367 3.9875 12.809 4.52461 13.3461C5.06172 13.8832 5.93398 13.8832 6.47109 13.3461L10.3125 9.50898L12.7789 11.9754C13.316 12.5125 14.1883 12.5125 14.7254 11.9754L20.2254 6.47539L20.2211 6.47109Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_431"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H22V22H0V0Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDbGraph);
export default __webpack_public_path__ + "static/media/db-graph.85e7c7e209bab782c7c40c2c7fff794c.svg";
export { ForwardRef as ReactComponent };